import { ANPREvent } from 'domain/anpr-event'
import { downloadCsv, buildCsvFilename } from 'shared/utils/csv-export'
import { isSpeedViolation } from './speed-violation-filter'

const CSV_HEADERS = [
    'Placa',
    'Velocidade (km/h)',
    'Limite de Velocidade (km/h)',
    'Infração de Velocidade',
    'Câmera',
    'Data/Hora',
    'Tipo de Veículo',
    'Cor',
    'URL Imagem Placa',
    'URL Imagem Detecção',
]

const formatRow = (event: ANPREvent): (string | number)[] => {
    const date = new Date(event.createdDate).toLocaleString('pt-BR')
    return [
        event.licensePlate ?? '',
        event.speed ?? 0,
        event.cameraSpeedLimit ?? 0,
        isSpeedViolation(event) ? 'Sim' : 'Não',
        event.cameraName ?? '',
        date,
        event.vehicleType ?? '',
        event.vehicleColor ?? '',
        event.licensePlateImagePath ?? '',
        event.detectionImagePath ?? '',
    ]
}

export const exportANPREventsToCSV = (
    events: ANPREvent[],
    filename?: string
): void => {
    downloadCsv(CSV_HEADERS, events.map(formatRow), filename ?? buildCsvFilename('eventos-anpr'))
}